export default "__VITE_ASSET__D10QNWtH__"